<template>
  <!-- 8张图样式 -->
    <div
      id="eightPic"
      class="eightPic"
      v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    >
    <div class="pic-group">
        <img  :src="tbInfo.image1"  class="pic" />
        <img  :src="tbInfo.image2"  class="pic" />
        <img  :src="tbInfo.image3"  class="pic" />
        <img  :src="tbInfo.image4"  class="pic rightmost" />
    </div>
     <div class="pic-group">
        <img  :src="tbInfo.image5"  class="pic" />
        <img  :src="tbInfo.image6"  class="pic" />
        <img  :src="tbInfo.image7"  class="pic" />
        <img  :src="tbInfo.image8"  class="pic rightmost" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "eightPic",
    data() {
      return {
        loading: false
      };
    },
    props: ["tbInfo","backgroundPic"],
    methods: {
    },
    computed: {
    },
    mounted() {
      
    }
  };
  </script>
  
  <style scoped>
  .eightPic {
    width: auto;
    height: 100%;
    background-position: center;
    background-size: cover;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 80px;
  }
  
  
  .pic-group {
    width: 100%;
    height: 242px;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 3px 0;
    margin-top: 10px;
    box-sizing: border-box;
  }
 
  .pic-group  img{
  margin: 10px 10px 10px 0px;
  width: 24%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  }
  
  .pic-group .rightmost{
  margin: 10px 0px 10px 0px;
  width: 24%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
  .eightPic .child-pic .link{
    cursor: pointer;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/comment/tbChildPage/eightPic.vue